import React from "react";

interface ITagItemProps {
    text: string;
    id: string;
    onTagDelete: (id: string) => void;
}

class TagItem extends React.Component<ITagItemProps> {
    constructor(props: Readonly<ITagItemProps>) {
        super(props);

        this.removeTag = this.removeTag.bind(this);
    }

    public render() {
        return (
            <span className="input-tag">
                <span>{this.props.text}</span>
                <button type="button" className="button btn-light btn-inline-right icon-times" onClick={this.removeTag} />
            </span>
        );
    }

    private removeTag() {
        this.props.onTagDelete(this.props.id);
    }
}

export default TagItem;
